import { FC, memo } from 'react';

import InstructorTemplate from '../../components/instructur-template/InstructorTemplate';
import { InstructorTemplateProps } from '../../components/instructur-template/type';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';

const DATA: InstructorTemplateProps = {
  cv: ['geboren 1981 in Deutschland'],
  name: 'Michael Prockl',
  school: {
    name: 'Systema Akademie Berlin',
    url: 'https://www.systema-berlin.de',
  },
  systema: [
    <>
      seit 2017 <Route href={RoutePath.SolovevStyle}>Solovev Defense</Route> (
      <Route href={RoutePath.FalkoZander}>Falko Zander</Route>)
    </>,
    <>
      <Route href={RoutePath.KampfkunstInstructorProgram}>Associate Instructor</Route>, Solovev
      Defense
    </>,
    <>
      <Route href={RoutePath.KampfkunstRanking}>5. Schülergrad</Route>, Solovev Defense
    </>,
  ],
};

const MichaelProckl: FC = () => <InstructorTemplate {...DATA} />;
export default memo(MichaelProckl);
